function baseUrl() {
  if (process.env.NODE_ENV !== "production") {
    return "http://localhost:9096/";
  } else {
    return "";
  }
}

const url = baseUrl();

export const authenticateUrl = `${url}api/authenticate`;
export const categoriesUrl = `${url}api/categories`;
export const linksUrl = `${url}api/links`;
export const archiveUrl = `${url}api/issues`;
export const statsUrl = `${url}api/stats`;
export const twitterHandleUrl = `${url}api/twitterHandle`;



// WEBPACK FOOTER //
// ./src/common/services/urls.js